// extracted by mini-css-extract-plugin
module.exports = {"prefixBadge":"PrefixBadge_prefixBadge__3fRvE"};